<template>
    <div>
        <div
            id="header-blogbgimg-box"
            v-if="isLoadingImage"
            style="
                background-image: url(/img/loading.svg);
                background-position: center;
                background-size: 20%;
            "
        ></div>
        <div
            v-else-if="isVisibleImageDom || !!imageUrl || !!selectedImage"
            id="header-blogbgimg-box"
            :style="
                'background-image: url(' +
                image +
                '); background-position: ' +
                convertedImagePosition +
                '; cursor:' +
                (isMovingImage ? 'grabbing' : 'grab') +
                ';background-size: ' + imageSize + ';'
            "
            @mousemove="onMouseMove"
            @mousedown="onMouseDown"
            @touchmove="onTouchMove"
            @touchstart="onTouchStart"
            @mouseup="onMouseUp"
            @touchend="onTouchEnd"
            @mouseleave="onMouseUp"
        ></div>
        <p v-if="isVisibleLocationSetting" class="blog_message_move_img">
            マウスでドラッグして↑↓に動かしてください。<br />お好みの位置に変更ができます。
        </p>
    </div>
</template>

<script>
import { onBeforeUpdate, onMounted, onUpdated, computed, reactive } from "vue";
import { ref, defineComponent } from "vue";

export default defineComponent({
    props: {
        imageUrl: String,
        selectedImage: String,
        imagePosition: String,
        isVisibleLocationSetting: Boolean,
        isVisibleImageDom: Boolean,
        isLoadingImage: Boolean,
        imageUrl: String,
        rangeSize: Object,
        ratio: Number,
        imageSize: Object,
    },
    setup(props, context) {
        const curX = ref(0);
        const curY = ref(0);
        const startX = ref(0);
        const startY = ref(0);
        const dX = ref(0);
        const dY = ref(0);
        const isMovingImage = ref(false);
        const imageNewPosition = computed(() => {
            return props.imagePosition;
        });
        const imageSize = computed(() => {
            if(props.imageSize?.width && props.imageSize?.height) {
                return ( props.ratio * props.imageSize.width ) + 'px ' + ( props.ratio * props.imageSize.height ) + 'px';
            }
            return 'cover';
        });
        const convertedImagePosition = computed(() => {
            let tmpY = props.imagePosition.match(/top\ (-?[0-9]+)px/);
            let tmpX = props.imagePosition.match(/left\ (-?[0-9]+)px/);

            let hoge = (
                "top " +
                (tmpY != null ? Math.floor(tmpY[1]) * props.ratio : 0) +
                "px" +
                " left " +
                (tmpX != null ? Math.floor(tmpX[1]) * props.ratio : 0) +
                "px"
            );
            return hoge;
        });
        const image = computed(() => {
            return !!props.selectedImage ? props.selectedImage : props.imageUrl;
        });

        /**
         * 画像移動：PC
         */
        const onMouseDown = (event) => {
            if (!props.isVisibleLocationSetting) return;

            dY.value = 0;
            dX.value = 0;

            if (event.touches && event.touches[0]) {
                startX.value = event.touches[0].clientX;
                startY.value = event.touches[0].clientY;
            } else if (event.clientX && event.clientY) {
                startX.value = event.clientX;
                startY.value = event.clientY;
            }

            isMovingImage.value = true;
        };
        /**
         * 画像移動：スマホ
         */
        const onTouchStart = (event) => {
            if (!props.isVisibleLocationSetting) return;

            dY.value = 0;
            dX.value = 0;

            if (event.touches && event.touches[0]) {
                startX.value = event.touches[0].clientX;
                startY.value = event.touches[0].clientY;
            } else if (event.clientX && event.clientY) {
                startX.value = event.clientX;
                startY.value = event.clientY;
            }

            isMovingImage.value = true;
        };
        /**
         * 画像移動：PC
         */
        const onMouseMove = (event) => {
            if (!props.isVisibleLocationSetting) return;

            if (!isMovingImage.value) return;

            let tmpY = convertedImagePosition.value.match(/top\ (-?[0-9]+)px/);
            let tmpX = convertedImagePosition.value.match(/left\ (-?[0-9]+)px/);

            let topOffsetX = tmpX != null ? Math.floor(tmpX[1]) : 0;
            let topOffsetY = tmpY != null ? Math.floor(tmpY[1]) : 0;

            if (event.touches && event.touches[0]) {
                curX.value = event.touches[0].clientX;
                curY.value = event.touches[0].clientY;
            } else if (event.clientX && event.clientY) {
                curX.value = event.clientX;
                curY.value = event.clientY;
            }

            var move_speed_ratio = 2.0;
            dX.value = move_speed_ratio * (curX.value - startX.value);
            dY.value = move_speed_ratio * (curY.value - startY.value);

            topOffsetX = Math.floor((topOffsetX - dX.value) / props.ratio);
            topOffsetY = Math.floor((topOffsetY - dY.value) / props.ratio);

            if (topOffsetY < -props.rangeSize.height) {
                topOffsetY = -props.rangeSize.height;
            } else if (topOffsetY > 0) {
                topOffsetY = 0;
            }

            if (topOffsetX < -props.rangeSize.width) {
                topOffsetX = -props.rangeSize.width;
            } else if (topOffsetX > 0) {
                topOffsetX = 0;
            }

            startY.value = curY.value;
            startX.value = curX.value;

            let hoge =
                "top " + topOffsetY + "px" + " left " + topOffsetX + "px";
            context.emit("update-location", hoge);
        };
        const onTouchMove = (event) => {
            if (!props.isVisibleLocationSetting) return;
        };
        const onMouseUp = (event) => {
            if (!props.isVisibleLocationSetting) return;

            isMovingImage.value = false;
        };
        const onTouchEnd = (event) => {
            if (!props.isVisibleLocationSetting) return;

            isMovingImage.value = false;
        };
        return {
            onMouseMove,
            onMouseDown,
            onTouchMove,
            onTouchStart,
            onMouseUp,
            onTouchEnd,
            curX,
            curY,
            startX,
            startY,
            dX,
            dY,
            isMovingImage,
            imageNewPosition,
            image,
            convertedImagePosition,
            imageSize
        };
    },
});
</script>
